const Modal = ({ losesAccess, setOpen }) => {
  const validAccess = async () => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setOpen(true);
  };

  return { validAccess };
};

export default Modal;
